<script setup lang="ts">

import CountUp from 'vue-countup-v3'
import { ref, watch } from 'vue'

const props = defineProps<{
  coins: number
  duration?: number
}>()

const startValue = ref(props.coins)
const coinsToShow = ref(startValue.value)

watch(() => props.coins, (coins, oldValue) => {
  startValue.value = oldValue
  coinsToShow.value = coins
})
</script>

<template>
  <CountUp
    :start-val="startValue"
    :end-val="coinsToShow"
    :options="{separator: ','}"
    :duration="duration ?? 1.5"
  />
</template>

<style scoped>

</style>